import { Box, styled } from "@mui/material";

export const SearchContainer = styled(Box)(() => ({
  width: 374,
}));
